import * as d3ScaleChromatic from 'd3-scale-chromatic'
import * as d3Scale from 'd3-scale'

const colorScale = d3Scale.scaleOrdinal(d3ScaleChromatic.schemePaired)
let colorNumber = 0
let size: Function
let gKey = 0
const color_standard = '#1961ac' // bleu marine
const color_cascade = '#ff7f00' // orange
const color_transfert =  '#b2df8a' // vert

function initColor(data: Mdata, nodeColor?: string) {
  // console.log('initColor', data)
  // console.log('initColor', nodeColor)
  let color
  if (data.generation) {
    // si c'est privé
    if (data.cascade) {
      color = color_cascade
    // } else if (!data.private && data.poubelle) {
    //   color = color_cascade
    // } else if (!data.private && data.cascade) {
    //   color = color_cascade
    } else if (data.private && !data.cascade) {
      color = color_transfert
    } else if (!data.left) {
      if (data.cascade) {
        color = color_cascade
      } else {
        // color = nodeColor || colorScale(`${colorNumber += 1}`)
        color = color_standard
      }
    } else {
      color = '#000'
    }
  } else {
    // c'est le premier node
    color = color_standard
  }
  data.color = color
  const { children, _children, options } = data
  if (children) {
    let privateNode = 0
    let cascadeNode = 0
    if (data.private && data.cascade) {
      // console.log('children private et cascade')
      color = color_cascade // orange
      privateNode = 1
      cascadeNode = 1
    } else if (!data.private && data.cascade) {
      color = color_cascade // orange
      privateNode = 0
      cascadeNode = 1
    } else if (data.private && !data.cascade) {
      color = color_transfert
      privateNode = 1
      cascadeNode = 0
    }
    for (let i = 0; i < children.length; i += 1) {
      if (data.id !== '0') {
        children[i].private = privateNode
        children[i].cascade = cascadeNode
      }
      initColor(children[i], color)
    }
  }
  if (_children) {
    let privateNode = 0
    let cascadeNode = 0
    if (data.private && data.cascade) {
      color = color_cascade // orange
      privateNode = 1
      cascadeNode = 1
    } else if (!data.private && data.cascade) {
      color = color_cascade // orange
      privateNode = 0
      cascadeNode = 1
    } else if (data.private && !data.cascade) {
      color = color_transfert
      privateNode = 1
      cascadeNode = 0
    }
    for (let i = 0; i < _children.length; i += 1) {
      if (data.id !== '0') {
        _children[i].private = privateNode
        _children[i].cascade = cascadeNode
      }
      initColor(_children[i], color)
    }
  }
  if (options) {
    let privateNode = 0
    let cascadeNode = 0
    if (data.private && data.cascade) {
      color = color_cascade // orange
      privateNode = 1
      cascadeNode = 1
    } else if (!data.private && data.cascade) {
      color = color_cascade // orange
      privateNode = 0
      cascadeNode = 1
    } else if (data.private && !data.cascade) {
      color = color_transfert
      privateNode = 1
      cascadeNode = 0
    }
    for (let i = 0; i < options.length; i += 1) {
      if (data.id !== '0') {
        options[i].private = privateNode
        options[i].cascade = cascadeNode
      }
      initColor(options[i], color)
    }
  }
}

function initSize(node: Mdata) { // size
  // console.log('initSize node', node)
  if (node.title) {
    // console.log('initSize node.title', node.title)
    // const lengthTitle:number = node.title.length
    // const lengthLabel:number = node.conditionsLabel ? node.conditionsLabel.length : node.title.length
    // const compareSize = lengthTitle < lengthLabel
    // console.log('initSize lengthTitle', lengthTitle)
    // console.log('initSize lengthLabel', lengthLabel)
    // console.log('initSize compareSize', compareSize)
    // console.log('initSize node.conditionsLabel', node.conditionsLabel)
    // console.log('initSize node.title', node.title)
    // si c'est le node 0
    if (!node.generation) {
      node.size = size(node.title) // il faut prendre uniquement la taille du title
      node.optionSize = size(node.conditionsLabel) // il faut prendre uniquement la taille du title
    } else {
      // console.log(node.conditionsLabel + ' < '+  node.title)
      // console.log(node.conditionsLabel.length + ' < '+  node.title.length)
      if (node.conditionsLabel.length < node.title.length) {
        // console.log('titre plus grand')
        node.size = size(node.title)
      } else {
        // console.log('option plus grande ou égale')
        node.size = size(node.conditionsLabel)
      }
      node.optionSize = size(node.conditionsLabel)
    }

  } else if (node.name) {
    // console.log('initSize node.name', node.name)
    node.size = size(node.name)
  }
  // console.log('initSize node', node.size)
  // console.log('initSize node.size', node.size)
  const { children, _children, options } = node
  // console.log('initSize children', children)
  // console.log('initSize _children', _children)
  // console.log('initSize options', options)
  if (children) {
    for (let i = 0; i < children.length; i += 1) {
      initSize(children[i])
    }
  }
  if (_children) {
    for (let i = 0; i < _children.length; i += 1) {
      initSize(_children[i])
    }
  }
  if (options) {
    for (let i = 0; i < options.length; i += 1) {
      initSize(options[i])
    }
  }
}

function _getSource(d: Mdata) {
  const { children, _children, options } = d
  const nd: Data = {
    name: d.title
  }
  nd.left = d.left
  if (children) {
    const { length } = children
    nd.children = new Array(length)
    for (let i = 0; i < length; i++) {
      nd.children[i] = _getSource(children[i])
    }
  }
  if (_children) {
    const { length } = _children
    nd._children = new Array(length)
    for (let i = 0; i < length; i++) {
      nd._children[i] = _getSource(_children[i])
    }
  }
  if (options) {
    const { length } = options
    nd.options = new Array(length)
    for (let i = 0; i < length; i++) {
      nd.options[i] = _getSource(options[i])
    }
  }
  return nd
}

function initId(d: Mdata, id = '0') {
  d.id = id
  d.gKey = d.gKey || (gKey += 1)
  // console.log('initId d:', d)
  // console.log('initId id:', id)
  const { children, _children, options } = d
  // console.log('children.length', children)
  if (children?.length && _children?.length && options?.length) {
    console.error('[Mindmap warn]: Error in data: data.children and data._children cannot contain data at the same time')
  } else {
    if (children) {
      for (let i = 0; i < children.length;) {
        if (children[i].id === 'del') {
          children.splice(i, 1)
        } else if (children[i].conditionsLabel === null) { // efface les noeuds qui ne sont plus dans leur parent (corrompu)
          children.splice(i, 1)
        } else if (children[i].type === 'faq') {
          children.splice(i, 1)
        } else {
          initId(children[i], `${id}-${i}`)
          i += 1
        }
      }
    }
    if (_children) {
      for (let i = 0; i < _children.length;) {
        if (_children[i].id === 'del') {
          _children.splice(i, 1)
        } else if (_children[i].conditionsLabel === null) { // efface les noeuds qui ne sont plus dans leur parent (corrompu)
          _children.splice(i, 1)
        } else if (_children[i].type === 'faq') {
          _children.splice(i, 1)
        } else {
          initId(_children[i], `${id}-${i}`)
          i += 1
        }
      }
    }
    if (options) {
      for (let i = 0; i < options.length;) {
        if (options[i].id === 'del') {
          options.splice(i, 1)
        } else {
          initId(options[i], `${id}-${i}`)
          i += 1
        }
      }
    }
  }
}

function initLeft(d: Mdata, left = false) {
  d.left = left
  const { children, _children, options } = d
  if (children) {
    for (let i = 0; i < children.length; i += 1) {
      initLeft(children[i], d.left)
    }
  }
  if (_children) {
    for (let i = 0; i < _children.length; i += 1) {
      initLeft(_children[i], d.left)
    }
  }
  if (options) {
    for (let i = 0; i < options.length; i += 1) {
      initLeft(options[i], d.left)
    }
  }
}

// restoration d'un node par son clone
function restoreNode(data: Mdata, cloneNode: Mdata) {
  // console.log('restoreNode data', data)
  // console.log('restoreNode cloneNode', cloneNode)
  const { children, _children, options } = data

  // regarde si c'est pas dans le node 0
  if (data.id == cloneNode.id) {
    // console.log('remplace le node 0 par son clone')
    data.output = cloneNode.output
    data.title = cloneNode.title
    data.next_step = cloneNode.next_step
    if (children) {
      data.children = cloneNode.children
    }
    if (_children) {
      data._children = cloneNode._children
    }
    return
  }


  if (children) {
    for (let i = 0; i < children.length; i += 1) {
      if (children[i].id == cloneNode.id) {
        // console.log('trouvé de node children.id', children[i].id)
        children[i] = cloneNode
        return
      }
      // check aussi les enfants
      restoreNode(children[i], cloneNode)
    }
  }
  if (_children) {
    for (let i = 0; i < _children.length; i += 1) {
      if (_children[i].id == cloneNode.id) {
        // console.log('trouvé de node _children.id', _children[i].id)
        _children[i] = cloneNode
        return
      }
      // check aussi les enfants
      restoreNode(_children[i], cloneNode)
    }
  }
}

// changement dans un node du "next_step"
function changeNextStep(data: Mdata, id:any, nextStep: any) {
  const { children, _children} = data
  if (children) {
    children.forEach((childNode) => {
      if (childNode.id == id) {
        if(nextStep === 'efface') {
          childNode.next_step = ''
        } else {
          childNode.next_step = nextStep
        }
        return
      }
      changeNextStep(childNode, id, nextStep)
    })
  }
  if (_children) {
    _children.forEach((childNode) => {
      if (childNode.id == id) {
        if(nextStep === 'efface') {
          childNode.next_step = ''
        } else {
          childNode.next_step = nextStep
        }
        return
      }
      changeNextStep(childNode, id, nextStep)
    })
  }
}

// Recherche un node par son dialog_node
function recherchedialogNode(data: Mdata, dialogNode: string, callback:any) { // id
  // console.log('recherchedialogNode dialogNode:', dialogNode)
  // let node = null
  const { children, _children } = data
  if (children) {
    children.forEach((childNode) => {
      if (childNode.dialog_node == dialogNode) {
        // console.log('recherchedialogNode childNode trouvée', childNode)
        return callback({
          'nodeFind': childNode
        })
      }
      recherchedialogNode(childNode, dialogNode, callback)
    })
  }
  if (_children) {
    _children.forEach((childNode) => {
      if (childNode.dialog_node == dialogNode) {
        // console.log('recherchedialogNode _childNode trouvée', childNode)
        return callback({
          'nodeFind': childNode
        })
      }
      recherchedialogNode(childNode, dialogNode, callback)
    })
  }
  // console.log('recherchedialogNode rien trouvé ')
  // return node
}

// recheche un node par sont id
function rechercheNodeId(data: Mdata, id: string, callback:any) { // id
  // console.log('rechercheNodeId data:', data)
  // console.log('rechercheNodeId id:', id)
  // let node = null
  const { children, _children } = data
  // regarde si c'est pas dans le node 0
  if (data.id == id) {
    // console.log('rechercheNodeId trouvée mais c\'est le node 0')
    return callback({
      'nodeFind': data
    })
  }
  // puis les enfants visibles
  if (children) {
    children.forEach((childNode) => {
      if (childNode.id == id) {
        // console.log('rechercheNodeId childNode trouvée', childNode)
        // node = childNode
        // return node
        // return childNode
        return callback({
          'nodeFind': childNode
        })
      }
      rechercheNodeId(childNode, id, callback)
    })
  }
  // et les enfants invisibles
  if (_children) {
    _children.forEach((childNode) => {
      if (childNode.id == id) {
        // console.log('rechercheNodeId _childNode trouvée', childNode)
        // node = childNode
        // return node
        // return childNode
        return callback({
          'nodeFind': childNode
        })
      }
      rechercheNodeId(childNode, id, callback)
    })
  }
  // console.log('rechercheNodeId rien trouvé ')
  // return node
}

// changement dans un node par son clone
function changeNode(data: Mdata, cNode: Mdata) {
  // console.log('changeNode data', data)
  // console.log('changeNode cNode', cNode)
  const { children, _children} = data
  // const output:any = data
  // console.log('changeNode children', children)
  // console.log('changeNode _children', _children)
  // console.log('changeNode output', output)
  if (children) {
    children.forEach((childNode) => {
      if (childNode.id == cNode.id) {
        childNode = cNode
        return
      }
      changeNode(childNode, cNode)
    })
  }
  if (_children) {
    _children.forEach((childNode) => {
      if (childNode.id == cNode.id) {
        childNode = cNode
        return
      }
      changeNode(childNode, cNode)
    })
  }
}

// ...
function changeOutputNode(data: Mdata, cNode: Mdata, output: any) {
  // console.log('changeOutputNode cnode :', cNode)
  // console.log('changeOutputNode output :', output)
  const {children, _children} = data
  // si c'est le node 0
  if (data.id == cNode.id) {
    // si les children sont visible
    if (children) {
      children.forEach((childNode:any) => {
        const newArray =  childNode.conditions.split(':')
        const inputOption = newArray[1] // la condition du children
        // il faut modifier le titre des childrens
        // recherche l'object options dans le output
        output.generic.forEach((elm:any, index:number) => {
          if (elm.options) {
            Object.keys(elm.options).forEach((i, index) => {
              // si corespondance entre la condition de l'option et du children
              if (elm.options[i].value.input.text == inputOption) {
                // modification du conditionslabel 
                if (childNode.conditionsLabel) {
                  // console.log('trouvé children :', childNode.id)
                  childNode.conditionsLabel = elm.options[i].label
                }
                // modification du label 
                if (childNode.label) {
                  childNode.label = elm.options[i].label
                }
              }
            })
          }
        })
      })
    }
    // si les children sont masqué
    if (_children) {
      console.log('changeOutputNode _children output :', output)
      _children.forEach((childNode:any) => {
        const newArray =  childNode.conditions.split(':')
        const inputOption = newArray[1] // la condition du children
        // il faut modifier le titre des childrens
        // recherche l'object options dans le output
        output.generic.forEach((elm:any, index:number) => {
          if (elm.options) {
            Object.keys(elm.options).forEach((i, index) => {
              // si corespondance entre la condition de l'option et du children
              if (elm.options[i].value.input.text == inputOption) {
                // modification du conditionslabel 
                if (childNode.conditionsLabel) {
                  // console.log('trouvé children :', childNode.id)
                  childNode.conditionsLabel = elm.options[i].label
                }
                // modification du label 
                if (childNode.label) {
                  childNode.label = elm.options[i].label
                }
              }
            })
          }
        })
      })
    }
    return
  }
  // pour tous les autres node
  if (children) {
    children.forEach((child:any) => {
      if (child.id == cNode.id) {
        child.output = output // modification des option du node
        child.children.forEach((childNode:any) => {
          // console.log('children trouvé ', childNode.id)
          const newArray =  childNode.conditions.split(':')
          const inputOption = newArray[1] // la condition du children
          // il faut modifier le titre des childrens
          // recherche l'object options dans le output
          output.generic.forEach((elm:any) => {
            if (elm.options) {
              Object.keys(elm.options).forEach((conditionName, index) => {
                // si corespondance entre la condition de l'option et du children
                if (elm.options[conditionName].value.input.text == inputOption) {
                  // console.log('option trouvé ', elm.options[conditionName])
                  // modification du conditionslabel 
                  if (childNode.conditionsLabel) {
                    // console.log('trouvé children :', childNode.id)
                    childNode.conditionsLabel = elm.options[conditionName].label
                  }
                  // modification du label 
                  if (childNode.label) {
                    childNode.label = elm.options[conditionName].label
                  }
                }
              })
            }
            changeNode(childNode, cNode)
          })
          return
        })
      }
      changeOutputNode(child, cNode, output)
    })
  }
  if (_children) {
    _children.forEach((child:any) => {
      if (child.id == cNode.id) {
        child.output = output // modification des option du node
        child.children.forEach((childNode:any) => {
          // console.log('children trouvé ', childNode.id)
          const newArray =  childNode.conditions.split(':')
          const inputOption = newArray[1] // la condition du children
          // il faut modifier le titre des childrens
          // recherche l'object options dans le output
          output.generic.forEach((elm:any) => {
            if (elm.options) {
              Object.keys(elm.options).forEach((conditionName, index) => {
                // si corespondance entre la condition de l'option et du children
                if (elm.options[conditionName].value.input.text == inputOption) {
                  // console.log('option trouvé ', elm.options[conditionName])
                  // modification du conditionslabel 
                  if (childNode.conditionsLabel) {
                    // console.log('trouvé children :', childNode.id)
                    childNode.conditionsLabel = elm.options[conditionName].label
                  }
                  // modification du label 
                  if (childNode.label) {
                    childNode.label = elm.options[conditionName].label
                  }
                }
              })
            }
            changeNode(childNode, cNode)
          })
          return
        })
      }
      changeOutputNode(child, cNode, output)
    })
  }
}

// ajoute l'option
function addOptionParent (output:any, newOpt:any) {
  const allOptions = output
  const newArray =  newOpt.conditions.split(':')
  const inputOption = newArray[1]
  const newOption = {
    label : newOpt.conditionsLabel,
    value: {
      input: {
        text : inputOption
      }
    }
  }
  // console.log('addOptionParent new option', newOption)
  // console.log('addOptionParent all options', allOptions.generic)
  if (Object.keys(allOptions.generic).length) {
    // retouve le tableau des options
    allOptions.generic.forEach((elm:any) => {
      // si trouvé des options
      if (elm.options) {
        // ajoute la nouvelle option
        elm.options.push(newOption)
      }
    })
  }
}

// efface l'option 
function delOptionByLabel (output:any, del:any) {
  // console.log('efface option', output)
  //recherche la reference du node dans les options
  const newArray =  del.conditions.split(':')
  const inputOption = newArray[1]
  const allOptions = output
  // console.log('allOptions.generic.length', allOptions.generic.length)
  if (Object.keys(allOptions.generic).length) {
    // retouve le tableau des options
    allOptions.generic.forEach((elm:any) => {
      // si trouvé des options
      if (elm.options) {
        Object.keys(elm.options).forEach(( index) => {
          // console.log(' index :' + index + ' :: ' + elm.options[index].value.input.text)
            if(elm.options[index] && elm.options[index].value.input.text === inputOption){
              // console.log ('option trouvé', elm.options[index].value.input.text)
              // delete elm.options[index]
              elm.options.splice(index, 1)
            }
        })
      }
    })
  }
}

// ajoute une option dans le output du node
// function addOptionNode(data: Mdata, cNode: Mdata, optionReturn: any) {
//   // console.log('addOptionNode data', data)
//   // console.log('addOptionNode cNode', cNode)
//   // console.log('addOptionNode optionReturn', optionReturn)
//   const { children, _children} = data
//   // const output:any = data
//   if (children) {
//     children.forEach((childNode) => {
//       if (childNode.id == cNode.id) {
//         // console.log('option trouvée', optionReturn.outputNode)
//         childNode.output = optionReturn.outputNode
//         return
//       }
//       addOptionNode(childNode, cNode, optionReturn)
//     })
//   }
//   if (_children) {
//     _children.forEach((childNode) => {
//       if (childNode.id == cNode.id) {
//         childNode.output = optionReturn.outputNode
//         return
//       }
//       addOptionNode(childNode, cNode, optionReturn)
//     })
//   }
// }

function deplaceCascade(d: Mdata, parent = 'node_2') {
  // console.log('deplaceCascade', d)
  d.parent = parent
  const { children, _children, options } = d
  if (children) {
    for (let i = 0; i < children.length; i += 1) {
      deplaceCascade(children[i], 'node_2')
    }
  }
  if (_children) {
    for (let i = 0; i < _children.length; i += 1) {
      deplaceCascade(_children[i], 'node_2')
    }
  }
  if (options) {
    for (let i = 0; i < options.length; i += 1) {
      deplaceCascade(options[i], 'node_2')
    }
  }
}


// deploie toutes les branches
function expandeAllbranches(data: any) {
  // console.log('expandeAllbranches', data.children)
  const { children, _children } = data
  // console.log('expandeAllbranches children', children)
  // console.log('expandeAllbranches _children', _children)
  if (children) {
    children.forEach((child:any) => {
      expandeAllbranches(child)
    })
  }
  if (_children) {
    _children.forEach((_child:any, index:number) => {
      // console.log('_child', _child)
      // console.log('_child index', index)
      expandeAllbranches(_child)
      data.children.push(_child)
      // _children.splice(index, 1)
    })
  }
  // console.log('expandeAllbranches suite', data)
  data._children = []
}

class ImData {
  data: Mdata
  constructor(d: Data, fn: Function) {
    // console.log('ImData Data', d)
    size = fn
    this.data = JSON.parse(JSON.stringify(d))
    console.log('ImData', this.data)
    initId(this.data)
    initColor(this.data)
    initSize(this.data)
    this.data.left = false
    const { children, _children, options } = this.data
    if (children) {
      // console.log('children', children)
      for (let i = 0; i < children.length; i += 1) {
        initLeft(children[i], children[i].left)
        if(children[i].cascade && children[i].generation == 0) {
          deplaceCascade (children[i], 'node_2')
        }
      }
    }
    if (_children) {
      for (let i = 0; i < _children.length; i += 1) {
        initLeft(_children[i], _children[i].left)
      }
    }
    if (options) {
      for (let i = 0; i < options.length; i += 1) {
        initLeft(options[i], options[i].left)
      }
    }
  }

  getSource(id = '0') {
    const d = this.find(id)
    return d ? _getSource(d) : { name: '' }
  }

  resize(id = '0') { // size
    const data = this.data
    rechercheNodeId(data, id, function(message:any) {
      // console.log('::resize retour message', message)
      if (message.nodeFind) {
        initSize(message.nodeFind)
      }
    })
    // const d = this.find(id)
    // if (d) {
    //   initSize(d)
    // }
  }

  find(id: string) { // id
    // console.log('find id:', id)
    const array = id.split('-').map(n => ~~n)
    let data = this.data
    // console.log('find id:', id)
    for (let i = 1; i < array.length; i++) {
      if (data && data.children) {
        data = data.children[array[i]]
      } else { // No data matching id
        return null
      }
    }
    return data
  }

  // renome le node et change sa taille
  rename(id: string, name: string) {
    if (id.length > 0) {
      const d = this.find(id)
      if (d) {
        d.title = name
        d.size = size(name, d.id === '0')
      }
      return d
    }
  }

  // retracte une branche
  collapse(id: string | string[]) {
    const arr = Array.isArray(id) ? id : [id]
    for (let i = 0; i < arr.length; i++) {
      const idChild = arr[i]
      const data = this.data
      rechercheNodeId(data, idChild, function(message:any) {
        // console.log('::collapse retour message', message)
        if (message.nodeFind) {
          const d = message.nodeFind
          if (d && (!d._children || d._children.length === 0)) {
            d._children = d.children
            d.children = []
          }else if (d && (!d.options || d.options.length === 0)) {
            d.options = d.children
            d.children = []
          }
        }
      })
    }
  }

  // deplois une branche
  expand(id: string | string[]) {
    const arr = Array.isArray(id) ? id : [id]
    for (let i = 0; i < arr.length; i++) {
      const idChild = arr[i]
      const data = this.data
      rechercheNodeId(data, idChild, function(message:any) {
        // console.log('::expand retour message', message)
        if (message.nodeFind) {
          const d = message.nodeFind
          if (d && (!d.children || d.children.length === 0)) {
            d.children = d._children
            d._children = []
          }
        }
      })
    }
  }

  // deplois toute l'arborescence des node
  allExpande() {
    expandeAllbranches(this.data)
  }

  del(id: string | string[]) { // id
    const arr = Array.isArray(id) ? id : [id]
    let p:any
    for (let i = 0; i < arr.length; i++) {
      const idChild = arr[i]
      const idArr = idChild.split('-')
      if (idArr.length >= 2) { // parent
        const delIndex = idArr.pop()
        const data = this.data
        rechercheNodeId(data, idArr.join('-'), function(message:any) {
          // console.log('::expand retour message', message)
          if (message.nodeFind) {
            const parent = message.nodeFind
            if (delIndex && parent) {
              if (parent.children) {
                parent.children[~~delIndex].id = 'del' // id
              }
              if (p === undefined || (p.id.split('-').length > parent.id.split('-').length)) { // parent
                p = parent
              }
            }
          }
        })
      }
    }
    if (p) {
      initId(p, p.id)
    }
  }

  // ajoute un nouveau node
  add(id: string, child: Data) {
    // console.log('add new node id', id)
    // console.log('add new node child', child)
    const data = this.data
    rechercheNodeId(data, id, function(message:any) {
      // console.log('retour message', message)
      if (message.nodeFind) {
        const parent:any = message.nodeFind
        if (parent) {
          if ((parent._children?.length || 0) > 0) {
            parent.children = parent._children
            parent._children = []
          }
          if ((parent.options?.length || 0) > 0) {
            parent.children = parent.options
            parent.options = []
          }
          if (id == '0') {
            // insert l'option dans le nouveau parent
            addOptionParent (parent.output, child)
          }
          // console.log('add parent generation :', parent.generation )
          const c: Mdata = JSON.parse(JSON.stringify(child))
          // parent.children ? parent.children.push(c) : parent.children = [c]
          parent.children.push(c)
          initColor(c, parent.color || colorScale(`${colorNumber += 1}`))
          const timestamp = Date.now() // pour etre sur de ne pas avoir de doublons
          initId(c, `${parent.id}-${timestamp}`)
          // initId(c, `${parent.id}-${parent.children.length - 1}`)
          c.left = parent.left
          initSize(c)
          return c
        }
      }
    })
  }

  insert(id: string, d: Data, i = 0) {
    if (id.length > 2) {
      const idArr = id.split('-')
      const bId = idArr.pop()
      const pId = idArr.join('-')
      const data = this.data
      rechercheNodeId(data, pId, function(message:any) {
        // console.log('retour message', message)
        if (message.nodeFind) {
          const parent:any = message.nodeFind
          if (bId && parent) {
            const c: Mdata = JSON.parse(JSON.stringify(d))
            const pChildren = parent.children
            if (pChildren) {
              pChildren.splice(~~bId + i, 0, c)
              c.left = pChildren[~~bId].left
            }
            initColor(c, parent.color || colorScale(`${colorNumber += 1}`))
            initId(parent, parent.id)
            initSize(c)
            return c
          }
        }
      })
    }
  }

  move(delId: string, insertId?: string, i = 0) {
    if (delId.length > 2) {
      const data = this.data
      if (!insertId) {
        rechercheNodeId(data, delId, function(message:any) {
          // console.log('::move retour message del', message)
          if (message.nodeFind) {
            // on peut faire le changement
            initLeft(message.nodeFind, !message.nodeFind.left)
            // restoreNode(data, cloneNode)
          }
        })
        // const del = this.find(delId)
        // if (del) {
        //   initLeft(del, !del.left)
        // }
      } else if (insertId.length > 2) {
        const idArr = delId.split('-')
        const delIndexS = idArr.pop()
        const pId = idArr.join('-')
        const insertIndexS = insertId.split('-').pop()

        rechercheNodeId(data, pId, function(message:any) {
          // console.log('::move retour message insert', message)
          if (message.nodeFind) {
            const parent:any = message.nodeFind

            rechercheNodeId(data, insertId, function(message:any) {
              // console.log('::move retour message insert', message)
              if (message.nodeFind) {
                const insert:any = message.nodeFind
                // on peut faire le changement
                // initLeft(message.nodeFind, !message.nodeFind.left)
                // restoreNode(data, cloneNode)
                if (delIndexS && insertIndexS && insert && parent && parent.children) {
                  const delIndex = ~~delIndexS
                  let insertIndex = ~~insertIndexS
                  if (delIndex < insertIndex) {
                    insertIndex -= 1
                  }
                  const del = parent.children.splice(delIndex, 1)[0]
                  if (del.left !== insert.left) {
                    initLeft(del, insert.left)
                  }
                  parent.children.splice(insertIndex + i, 0, del)
                  initId(parent, parent.id)
                }
              }
            })
          }
        })
      }
    }
  }
  // restore un node qui n'a pas été enregistré
  restoreCloneNode (cloneNode: Mdata) {
    const data = this.data
    rechercheNodeId(data, cloneNode.id, function(message:any) {
      // console.log('::restoreCloneNode retour message', message)
      if (message.nodeFind) {
        // on peut faire le changement
        restoreNode(data, cloneNode)
      }
    })
  }

  // ajoute/change le nextStep d'un node
  changeNextStepNode (id:any, nextStep: string) {
    const data = this.data
    rechercheNodeId(data, id, function(message:any) {
      // console.log('::changeNextStepNode retour message', message)
      if (message.nodeFind) {
        // on peut faire le changement
        changeNextStep(data, id, nextStep)
      }
    })
  }

  // changement dans un node
  changeInNode (cNode: Mdata) {
    const data = this.data
    rechercheNodeId(data, cNode.id, function(message:any) {
      // console.log('::changeInNode retour message', message)
      if (message.nodeFind) {
        // on peut faire le changement
        changeNode(data, cNode)
      }
    })
  }

  // modification du output du node selectionné
  changeOutput (cNode: Mdata, output: Mdata) {
    // console.log('changeOutput cNode', cNode)
    // console.log('changeOutput output', output)
    const data = this.data
    rechercheNodeId(data, cNode.id, function(message:any) {
      // console.log('::changeOutput retour message', message)
      if (message.nodeFind) {
        // on peut faire le changement
        changeOutputNode(data, cNode, output)
        initSize(message.nodeFind)
        // initColor(message.nodeFind, colorScale(`${colorNumber += 1}`))
      }
    })
  }

  // Met a jour le output parent et supprime le children
  delNodeAndUpdateParent(nodeId: string, output: any) {
    // console.log('::delNodeAndUpdateParent data', this.data)
    // console.log('::delNodeAndUpdateParent nodeId', nodeId)
    // console.log('::delNodeAndUpdateParent output', output)
    const data = this.data
    rechercheNodeId(data, nodeId, function(retour:any) {
      // console.log('::rechercheNodeId retour message', retour)
      if (retour.nodeFind) {
        // on peut rechercher le parent
        recherchedialogNode(data, retour.nodeFind.parent, function(message:any) {
          // console.log('::recherchedialogNode retour message', message)
          if (message.nodeFind) {
            // on peut faire le changement
            const parent = message.nodeFind
            if (parent) {
              parent.output = output
              const pChildren = parent.children
              let idxToSplice = -1
              if (pChildren) {
                for (let i = 0; i < pChildren.length; i++) {
                  if (pChildren[i].id === nodeId) {
                    idxToSplice = i
                    break
                  }
                }
                if (idxToSplice !== -1 && typeof parent.children !== 'undefined') {
                  parent.children.splice(idxToSplice, 1)
                }
              }
            }
          }
        })
      }
    })
  }

  // Déplace un node dans un autre node (change de parent)
  reparent(newParent: any, node: any) {
    const newParentId = newParent.id
    const oldParentId = node.id
    if ( newParentId !== oldParentId) {
      // console.log('::reparent newParentId', newParentId)
      // console.log('::reparent oldParentId', oldParentId)
      // const np = this.find(newParentId)
      const idArr = oldParentId.split('-')
      const delIndex = idArr.pop()
      const delParentId = idArr.join('-')
      // console.log('idArr', idArr)
      // console.log('delParentId', delParentId)
      // console.log('delIndex', delIndex)
      
      const data = this.data
      rechercheNodeId(data, newParentId, function(message:any) {
        // console.log('::reparent newParentId retour message', message)
        if (message.nodeFind) {
          // on peut faire le changement
          const newParentNode = message.nodeFind

          rechercheNodeId(data, delParentId, function(message:any) {
            // console.log('::reparent oldParent retour message', message)
            if (message.nodeFind) {
              // on peut faire le changement
              const oldParent = message.nodeFind
              if (delIndex && oldParent && newParentNode) {
                oldParent.children.forEach((child:any, index:number) => {
                  if (child.id == oldParentId) {
                    // console.log('child trouvé : ', child)
                    // console.log('child index : ', index)
                    // console.log('oldParent.output', oldParent.output)
                    // console.log('newParent.output', newParent.output)
                    // efface l'option dans l'ancien parent
                    delOptionByLabel (oldParent.output, child)
                    // console.log('del :', del)
                    // si il y a quelque chose à effacer
                    if (child) {
                      (newParentNode.children?.length || 0) > 0 ? newParentNode.children?.push(child)
                        : ((newParentNode._children?.length || 0) > 0 ? newParentNode._children?.push(child) : newParentNode.children = [child])
                      
                      // insert l'option dans le nouveau parent
                      addOptionParent (newParent.output, child)

                        // on peut faire le changement
                      initColor(child, newParentId === '0' ? colorScale(`${colorNumber += 1}`) : newParentNode.color)
                      initLeft(child, newParentId === '0' ? child.left : newParentNode.left)
                      initId(child, `${newParentNode.id}-${newParentNode.children?.length - 1}`)
                      // initId(newParentNode, newParentNode.id)
                      // initId(oldParent, oldParent.id)
                    }
                    // efface le child du oldparent
                    oldParent.children.splice(index, 1)
                  }
                })
              }
            }
          })
        }
      })

    } else {
      // console.log('::Pas de reparent')
    }
  }
}

export default ImData
